module.exports = __webpack_public_path__ + "static/media/eyeOpen.07edfd10.svg";